/* tslint:disable */
/* eslint-disable */
/**
 * Melco Identity APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IdentityMelcoModelsCustomWarning
 */
export interface IdentityMelcoModelsCustomWarning {
    /**
     * 
     * @type {string}
     * @memberof IdentityMelcoModelsCustomWarning
     */
    key?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityMelcoModelsCustomWarning
     */
    source?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityMelcoModelsCustomWarning
     */
    message?: string | null;
}

export function IdentityMelcoModelsCustomWarningFromJSON(json: any): IdentityMelcoModelsCustomWarning {
    return IdentityMelcoModelsCustomWarningFromJSONTyped(json, false);
}

export function IdentityMelcoModelsCustomWarningFromJSONTyped(json: any, ignoreDiscriminator: boolean): IdentityMelcoModelsCustomWarning {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'key': !exists(json, 'key') ? undefined : json['key'],
        'source': !exists(json, 'source') ? undefined : json['source'],
        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function IdentityMelcoModelsCustomWarningToJSON(value?: IdentityMelcoModelsCustomWarning | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'key': value.key,
        'source': value.source,
        'message': value.message,
    };
}


